import { useAuthStore } from '@/stores/useAuthStore'
import type { TeamHoleByHoleData } from '@/types/dde/teamHoleByHole.types'

import { createWebSocketTableStore } from '../table'

const transformData = (rawData: TeamHoleByHoleData): TeamHoleByHoleData[] => {
  return [rawData]
}

export const useTeamHoleByHoleStore = createWebSocketTableStore({
  storeName: 'DDE Golf Pricing - Team Hole By Hole',
  features: {
    pagination: false,
    sorting: false,
    filtering: false
  },
  websocketConfig: {
    getUrl: (params: { tournamentId: number; teamNo: number }) =>
      `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${params.tournamentId}/teamholebyhole/${params.teamNo}?speed=fast`,
    transformData,
    getAuthToken: () => useAuthStore.getState().token,
    shouldReuseConnection: (currentParams, newParams) =>
      currentParams?.tournamentId === newParams?.tournamentId &&
      currentParams?.teamNo === newParams?.teamNo
  }
})
